import { useEffect, useState, useCallback, useRef } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import useWindowEvents from './useWindowEvents';

export default function useHomeEvents(openCalendarMessagingSummaryDrawer) {
    const [
        directMessageDrawerAthleteId,
        setDirectMessageDrawerAthleteId
    ] = useState(null);

    const [teamChannelTeamId, setTeamChannelTeamId] = useState(null);
    const referenceHandle = useRef();
    const dispatch = useDispatch();
    const directMessageSession = useRef({});
    const teamMessageSession = useRef({});
    const [filters, setFilters] = useState([]);
    const { emit, on } = useWindowEvents(referenceHandle);

    useEffect(
        () => {
            on('open-session-comment-drawer', data => {
                const {
                    programWorkoutId,
                    teamId,
                    title,
                    dateString,
                    athleteId
                } = data;
                dispatch(
                    openCalendarMessagingSummaryDrawer(
                        programWorkoutId,
                        teamId,
                        title,
                        dateString,
                        athleteId
                    )
                );

                teamMessageSession.current = data;
            });

            on('open-direct-message-drawer', data => {
                const { athleteId } = data;
                directMessageSession.current = data;
                setDirectMessageDrawerAthleteId(athleteId);
            });

            on('open-team-message-drawer', data => {
                const { teamId } = data;
                setTeamChannelTeamId(teamId);
            });

            on('filters-changed', data => {
                setFilters(data);
            });

            on('go-to-athlete-calendar', ({ athleteId, dateString }) => {
                const date = moment(dateString);
                window.location = `/athlete/${athleteId}/${date.year()}/${date.month() +
                    1}`;
            });

            on('go-to-team-calendar', ({ programId, dateString }) => {
                const date = moment(dateString);
                window.location = `/team/${programId}/${date.year()}/${date.month() +
                    1}`;
            });
        },
        /* eslint-disable-next-line */
        []
    );

    const onFilterChange = useCallback(
        filter => {
            emit('filter-selection-changed', filter);
        },
        [emit]
    );

    const onDateChange = useCallback(
        date => {
            emit('date-selection-changed', date);
        },
        [emit]
    );

    return {
        onFilterChange,
        onDateChange,
        filters,
        emit,
        directMessageSession,
        teamMessageSession,
        referenceHandle,
        directMessageDrawerAthleteId,
        setDirectMessageDrawerAthleteId,
        teamChannelTeamId,
        setTeamChannelTeamId
    };
}



// WEBPACK FOOTER //
// ./src/v5/home/components/hooks/useHomeEvents.js